import React, { useEffect, useState } from "react";
import { Routes, Route, Link } from "react-router-dom";
import { useAppState } from "../contexts/AppContext";
import Login from "./login";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import Clients from "../pages/Clients";
import Invoices from "../pages/Invoices";
import Auth, { checkAuth, logout, me } from "../helpers/Auth";
import ClientCreate from "../pages/ClientCreate";
import InvoiceCreate from "../pages/InvoiceCreate";
import Vendors from "../pages/Vendors";
import Users from "../pages/Users";
import UserCreate from "../pages/UserCreate";
import Dashboard from "../pages/Dashboard";
import Invoice from "../pages/Invoice";
import Products from "../pages/Products";
import Stores from "../pages/Stores";
import Brands from "../pages/Brands";
import BrandCreate from "../pages/BrandCreate";
import ProductsByStore from "../pages/ProductsByStore";
import Categories from "../pages/Categories";
import CategoryCreate from "../pages/CategoryCreate";
import AmazonCreate from "../pages/AmazonCreate";
import Product from "../pages/Product";
import Attributes from "../pages/Attributes";
import AttributeCreate from "../pages/AttributeCreate";
import Series from "../pages/Series";
import SeriesPage from "../pages/SeriesPage";
import SeriesCreate from "../pages/SeriesCreate";
import ProductMatchCandidatesPage from "../pages/ProductMatchCandidatesPage";
import AttributeValuesMergePage from "../pages/AttributeValuesMergePage";
import Collections from "../pages/Collections";
import CollectionEdit from "../pages/CollectionEdit";
import CollectionCreate from "../pages/CollectionCreate";

dayjs.extend(localizedFormat)
dayjs.extend(utc)
dayjs.extend(timezone)



export default function App() {
    const { appState, setAppState } = useAppState()

    useEffect(() => {
        Auth.me().then((data) => {
            setAppState({
                user: {
                    name: data.user.name,
                    email: data.user.email,
                }
            })
        })
    }, [])

    useEffect(() => {
        console.log(appState.user)
    }, [appState.user])

    if (!checkAuth()) {
        return <Login />
    }

    return (
        <>
            <header className="w-full">
                <nav className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 flex items-center justify-between">
                    <ul>
                        <li>
                            <Link className="text-lg font-medium" to="/">PriceHunt.ca</Link>
                        </li>
                    </ul>
                    <ul className="flex space-x-9">
                        <li>
                            <Link to="/products">Products</Link>
                        </li>
                        <li>
                            <Link to="/duplicates">Duplicates</Link>
                        </li>
                        <li>
                            <Link to="/attribute-merger">Attribute Merger</Link>
                        </li>
                        <li>
                            <Link to="/collections">Collections</Link>
                        </li>
                        <li>
                            <Link to="/categories">Categories</Link>
                        </li>
                        <li>
                            <Link to="/series">Series</Link>
                        </li>
                        <li>
                            <Link to="/attributes">Attributes</Link>
                        </li>
                        <li>
                            <Link to="/products-by-store">Products by store</Link>
                        </li>
                        <li>
                            <Link to="/stores">Stores</Link>
                        </li>
                        <li>
                            <Link to="/brands">Brands</Link>
                        </li>
                        <li>
                            <a href="#" onClick={logout}>Logout ({appState.user.email})</a>
                        </li>
                    </ul>
                </nav>
            </header>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col">
                <Routes>
                    <Route path="/" element={<Products />} />
                    <Route path="/attributes" element={<Attributes />} />
                    <Route path="/attributes/create" element={<AttributeCreate />} />
                    <Route path="/duplicates" element={<ProductMatchCandidatesPage />} />
                    <Route path="/attribute-merger" element={<AttributeValuesMergePage />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/products/:id" element={<Product />} />
                    <Route path="/products/:id/amazon" element={<AmazonCreate />} />
                    <Route path="/products-by-store" element={<ProductsByStore />} />
                    <Route path="/series" element={<Series />} />
                    <Route path="/series/create" element={<SeriesCreate />} />
                    <Route path="/series/:id" element={<SeriesPage />} />
                    <Route path="/collections" element={<Collections />} />
                    <Route path="/collections/create" element={<CollectionCreate />} />
                    <Route path="/collections/:id" element={<CollectionEdit />} />
                    <Route path="/categories" element={<Categories />} />
                    <Route path="/categories/create" element={<CategoryCreate />} />
                    <Route path="/brands" element={<Brands />} />
                    <Route path="/brands/create" element={<BrandCreate />} />
                    <Route path="/stores" element={<Stores />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/users/create" element={<UserCreate />} />
                </Routes>
            </div>
        </>
    )
}
